const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        bookAppointmentInfoText:
            'Wenn Sie schwanger sind oder vermuten, schwanger zu sein, rufen Sie und bitte unter +41 44 123 45 67 an und buchen Sie keinen Termin. Wir möchten sicherstellen, dass Sie die bestmögliche Betreuung erhalten. Wir werden Ihre Situation persönlich bewerten und direkt einen Termin für Sie vereinbaren.',
    },
    __RELATIVE_SOURCE_FILE__
);
